import { EnvironmentModel } from './environment.model'
import { environmentBase } from './environment.base'

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const BASE_API_URL = 'https://dev-api.galabid.com/'
// const API_URL = 'http://api.galabid.localhost/api/app/'
const BASE_APP_DOMAIN = 'dev.galabid.com'

export const environment: EnvironmentModel = {
  ...environmentBase,
  appBaseHref: `https://${BASE_APP_DOMAIN}`,
  baseApiUrl: BASE_API_URL,
  apiUrl: BASE_API_URL + 'api/app/', // app api calls
  production: false,
  name: 'development',
  appUrl: BASE_APP_DOMAIN,
  staticUrl: 'https://s3-ap-southeast-2.amazonaws.com/frontend.galabid.com/static/images/',
  refreshTokenUrl: 'refresh',
  pusher: {
    key: '36e9b2a6f233f15bb326',
    cluster: 'mt1',
  },
  stripe_publishable_key: 'pk_test_jBFPCNea9jnjDdt3pycwLjKO',
  realtimeService: 'pusher',
  googleOauthClientId: '823678877303-c0vfdj9j6jhf316q9orehfihaki8jtbg.apps.googleusercontent.com',
  facebookAppId: '1181296268937004',
  sentry_dsn: 'https://7467c48e3839441289ae0bfcb4b35589@o1230973.ingest.sentry.io/6540690',
  sentryEnabled: true,
  sentrySampleRate: 0.1,
  sentryTracesSampleRate: 0.1,
  dashboardUrl: 'https://dev-dashboard.galabid.com/',
  recaptchaSiteKey: '6LeyQc8aAAAAAPEzUl-JTzFQI9pFVkH2zMMx2xpM',
  googleMapsKey: 'AIzaSyCzumSELX-J1Z9Y_2Z7oDi-yV9XY11R4n4',
  googleAnalyticsMeasurementId: 'G-HX4YYRCP5P',
  networkCheckFallbackUrl: 'https://d30ba36ho674zz.cloudfront.net',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
